import React, { Component } from "react";
import { Link } from "react-router-dom";
import { bool, shape, string } from "prop-types";
import { connect } from "react-redux";
import { selectors as accountsSelectors } from "reducers/accounts";
import GridTable from "pages/_components/GridTable/GridTable";
import I18n from "pages/_components/I18n";
import ProductList from "pages/_components/product/List";
import Loader from "pages/_components/Loader";
import HistoricalBalanceItem from "./HistoricalBalanceItem";
import HistoricalBalancesFilter from "./HistoricalBalancesFilter";

class HistoricalBalancesList extends Component {
    static propTypes = {
        account: shape({
            idProduct: string,
        }).isRequired,
        date: string.isRequired,
        historicalBalances: shape({}).isRequired,
        historicalBalancesFetching: bool.isRequired,
        isDesktop: bool.isRequired,
    };

    state = {
        columns: this.props.isDesktop ? 6 : 2,
        rows: this.props.isDesktop ? 1 : 3,
        // date: new Date(),
    };

    renderItem = (historicalBalance) => {
        const { isDesktop, account, date } = this.props;
        const { columns, rows } = this.state;
        return (
            <GridTable.Container className="box-details" columns={columns} rows={rows}>
                <HistoricalBalanceItem
                    isDesktop={isDesktop}
                    historicalBalance={historicalBalance}
                    account={account}
                    date={date}
                    renderAs={Link}
                    to={`/accounts/${account.idProduct}`}
                    onClick={() => this.handleMovementClick()}
                />
            </GridTable.Container>
        );
    };

    renderList = (list) => {
        const { isDesktop, account, date, historicalBalancesFetching } = this.props;

        if (historicalBalancesFetching) {
            return <Loader />;
        }

        return (
            <>
                <HistoricalBalancesFilter account={account} date={date} />
                <GridTable className={isDesktop ? "scrollable" : "scrollable historical-balances-list"}>
                    {isDesktop ? (
                        <GridTable.Header>
                            <GridTable.Container key="HistoricalBalancesList" columns={3}>
                                <GridTable.Data columnStart={1} rowStart={1} alignY={isDesktop ? "left" : "middle"}>
                                    <I18n id="tableHeader.date" />
                                </GridTable.Data>
                                <GridTable.Data columnStart={2} alignX={isDesktop ? "center" : "right"}>
                                    <I18n id="tableHeader.balance" />
                                </GridTable.Data>
                                <GridTable.Data columnStart={3}> </GridTable.Data>
                            </GridTable.Container>
                        </GridTable.Header>
                    ) : null}
                    <GridTable.Body>{list}</GridTable.Body>
                </GridTable>
            </>
        );
    };

    render() {
        const { historicalBalances } = this.props;
        return (
            <>
                <ProductList
                    items={historicalBalances}
                    renderItem={this.renderItem}
                    noMoreDataText=""
                    loadMoreText=""
                    noDataText=""
                    noFiltersDataText="accounts.historicalBalances.filters.none">
                    {this.renderList}
                </ProductList>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    account: accountsSelectors.getSelectedAccount(state),
    date: accountsSelectors.getDate(state),
    fetching: accountsSelectors.getFetching(state),
    historicalBalances: accountsSelectors.getHistoricalBalances(state),
    historicalBalancesFetching: accountsSelectors.getHistoricalBalancesFetching(state),
});

export default connect(mapStateToProps)(HistoricalBalancesList);
